/* eslint-disable no-console */
import axios from "axios";
import Config from "@/config";
import { serverDomain, getSetting } from "@/config/index.js";
import store from "@/store";
import ApiUrl from "./ApiUrl";

let instance;
class Api {
  constructor() {
    if (!instance) {
      this.baseInit();
      this.youtubeInit();
      this.adminInit();
      // this.helpCenterInit();
      instance = this;
    }

    return instance;
  }

  baseInit() {
    if (!instance) {
      let baseUrl = window.location.origin;

      // if (process.env.NODE_ENV == "production") {
      //   baseUrl = Config.getSetting("baseURL");
      // }
      baseUrl = serverDomain();

      const urlParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlParams.entries());
      let gemSession = params.token
      const shopInfo = store.state.account.shopInfo;
      if (!gemSession && shopInfo) {
        gemSession = shopInfo.gemSession ?? localStorage.getItem(`__gemSession_${params.shop ?? shopInfo.shopifyDomain}`)
      }

      const settings = {
        baseURL: baseUrl,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Gem-Session": gemSession
        },
        withCredentials: true
      };

      const shopifyAppGp = "https://apps.shopify.com/gempages"

      this.base = axios.create(settings);

      this.base.interceptors.request.use(function (config) {
        if (config.url == ApiUrl.base.pricing.get.payment) {
          config.headers["X-Gem-Cookie-Override"] = true;
        }
        return config;
      }, function (error) {
        // Do something with request error
        return Promise.reject(error);
      });

      this.base.interceptors.response.use(
        response => {
          return response;
        },
        error => {
          const domain = "//" + window.location.host;
          if (error.response && error.response.status == 401) {
            if (error.response.data.code == "apC00001") {
              if (window.location.pathname.startsWith("/agency")) {
                window.location.replace(`${domain}/agency/login`);
              }
            } else if (error.response.data.code == "apC00000") {
              window.location.replace(shopifyAppGp);
            } else {
              window.location.replace(shopifyAppGp);
            }
          }
          return Promise.reject(error);
        }
      );
    }

    return this.base;
  }

  helpCenterInit() {
    if (!instance) {

      // local
      let helpCenterURL = "https://gem-help.herokuapp.com";

      if (process.env.NODE_ENV == "production") {
        helpCenterURL = Config.getSetting("helpCenterURL");
      }

      this.helpCenter = axios.create({
        paramsSerializer: (params) => { 
          let result = '';
          Object.keys(params).forEach(key => {
              result += `${key}=${encodeURIComponent(params[key])}&`;
          });
          return result.substr(0, result.length - 1);
        },
        baseURL: helpCenterURL,
        headers: {
          "app-name": "GemPages"
          // Authorization: "Bearer " + Cookie.get(Cookie.key)
          // Authorization: "Bearer " + localStorage.token
        }
      });
    }

    return this.helpCenter;
  }

  youtubeInit() {
    if (!instance) {
      this.youtube = axios.create({
        baseURL: "https://www.googleapis.com/youtube/v3",
        headers: {}
      });
    }

    return this.youtube;
  }

  adminInit() {
    if (!instance) {
      this.admin = axios.create({
        baseURL: getSetting("adminURL"),
        headers: {}
      });
    }

    return this.admin;
  }
}

export default new Api();
